import Navbar from '../components/Navbar/Navbar'
import Industrials from '../components/Industrials/Industrials'
import IndustrialProducts from '../components/IndustrialProducts/IndustrialProducts'
import Footer from '../components/Footer/Footer'


const Industrial = () => {
    return(
        <>
            <Navbar />
            <main className='industrial'>
                <h1>Frio Industrial</h1>
            </main>
            <Industrials />     
            <IndustrialProducts />
            <Footer />
        </>
    )
}

export default Industrial